var map = {
	"./Arbitrum_selected.png": "171e",
	"./Arbitrum_unselected.png": "3e4d",
	"./Avalanche_selected.png": "61f9",
	"./Avalanche_unselected.png": "f06b",
	"./BSC_selected.png": "02b3",
	"./BSC_unselected.png": "be15",
	"./EOS_selected.png": "8031",
	"./EOS_unselected.png": "5a9e",
	"./ETH_selected.png": "fec1",
	"./ETH_unselected.png": "a512",
	"./FTM_selected.png": "a418",
	"./FTM_unselected.png": "dd28",
	"./HSC_selected.png": "8a8d",
	"./HSC_unselected.png": "a6d5",
	"./Heco_selected.png": "496a",
	"./Heco_unselected.png": "e4c1",
	"./IOST_selected.png": "03c8",
	"./IOST_unselected.png": "7928",
	"./Klaytn_selected.png": "51c7",
	"./Klaytn_unselected.png": "c827",
	"./Kusama_selected.png": "eb34",
	"./Kusama_unselected.png": "a028",
	"./Matic_selected.png": "fa64",
	"./Matic_unselected.png": "cfa2",
	"./OEC_selected.png": "6abd",
	"./OEC_unselected.png": "b7bd",
	"./Optimistic_selected.png": "8fa1",
	"./Optimistic_unselected.png": "760a",
	"./Polkadot_selected.png": "6bea",
	"./Polkadot_unselected.png": "188e",
	"./Solana_selected.png": "91c1",
	"./Solana_unselected.png": "26d1",
	"./Subgame_selected.png": "dca2",
	"./Subgame_unselected.png": "5db2",
	"./TRON_selected.png": "ac27",
	"./TRON_unselected.png": "3b22",
	"./xDai_selected.png": "e1a9",
	"./xDai_unselected.png": "62f2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f0f4";